export enum AppRoute {
  home = '/',
  login = '/login',
  product = '/products/:id',
}
